// supabaseSearch.js - VERSIÓN CORREGIDA QUE FUNCIONA CON TU COMPONENTE
import { supabase } from '../../../supabaseClient';

export const searchPurchases = async (type, value) => {
  try {
    const clean = value.replace(/\D/g, '');
    if (!clean) {
      return {
        success: false,
        all: [],
        confirmed: [],
        pending: [],
        stats: { total: 0, confirmados: 0, pendientes: 0 }
      };
    }

    console.log('Búsqueda:', { type, clean });

    if (type === 'cedula') {
      const { data, error } = await supabase
        .from('purchases')
        .select('*')
        .or(`cedula.ilike.%${clean}%,cedula.ilike.%V${clean}%,cedula.ilike.%E${clean}%`)
        .in('estado', ['pendiente', 'confirmado', 'completado'])
        .order('created_at', { ascending: false });

      if (error) throw error;
      
      const all = data || [];
      const confirmed = all.filter(p => p.estado === 'confirmado' || p.estado === 'completado');
      const pending = all.filter(p => p.estado === 'pendiente');
      
      console.log('Resultados cédula:', all);
      
      return {
        success: true,
        all: all,
        confirmed: confirmed,
        pending: pending,
        stats: {
          total: all.length,
          confirmados: confirmed.length,
          pendientes: pending.length
        }
      };
    }

    if (type === 'ticket') {
      const num = parseInt(clean, 10);
      if (isNaN(num)) {
        return {
          success: false,
          all: [],
          confirmed: [],
          pending: [],
          stats: { total: 0, confirmados: 0, pendientes: 0 }
        };
      }

      const { data, error } = await supabase
        .from('purchases')
        .select('*')
        .contains('numeros', [num])
        .in('estado', ['pendiente', 'confirmado', 'completado'])
        .order('created_at', { ascending: false });

      if (error) throw error;
      
      const all = data || [];
      const confirmed = all.filter(p => p.estado === 'confirmado' || p.estado === 'completado');
      const pending = all.filter(p => p.estado === 'pendiente');
      
      console.log('Resultados ticket:', all);
      
      return {
        success: true,
        all: all,
        confirmed: confirmed,
        pending: pending,
        stats: {
          total: all.length,
          confirmados: confirmed.length,
          pendientes: pending.length
        }
      };
    }

    return {
      success: false,
      all: [],
      confirmed: [],
      pending: [],
      stats: { total: 0, confirmados: 0, pendientes: 0 }
    };
    
  } catch (error) {
    console.error('Error en searchPurchases:', error);
    return {
      success: false,
      all: [],
      confirmed: [],
      pending: [],
      stats: { total: 0, confirmados: 0, pendientes: 0 }
    };
  }
};

export default searchPurchases;